module.exports = __webpack_public_path__ + "img/targetBlue.adddcb10.jpg";